import {
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import useStyles from "../common/model/styles";
import closeIcon from "../../assets/closeModel.png";
import checkedIcon from "../../assets/check-mark.png";
import deleteIcon from "../../assets/trash.png";

import Popup from "../common/model/Popup";
import React, { useEffect, useState } from "react";
import SubscriptionPlanForm from "../../clientAdmin/components/settings/manageClient/SubscriptionPlanForm";
import { subscriptionPlanFields } from "./selectPlanFields";
import FormField from "../common/FormField";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import {
  resetSubscriptionLocal,
  setNewSubscriptionLocal,
} from "../../store/reducers/publicSlice";
import {
  addSubscriptionAction,
  setAddSubscriptionAction,
} from "../../store/reducers/adminCreationSlice";
import Notification from "../common/notification/Notification";
import { useNavigate } from "react-router-dom";
import ResetFormAlert from "./ResetFormAlert";
import { getClientForEditAction } from "../../store/reducers/adminClientsSlice";
import { getUserProfile } from "../../store/reducers/userSlice";
interface ManageSelectPlanProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectClient: any; // Adjust type as per your requirement
  action?: any;
  isNew?: boolean;
}

const ManageSelectPlan = (props: ManageSelectPlanProps) => {
  const { selectClient, onHide, open, title, isNew } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("sm"); // Adjust the type definition

  const { plans, newSubscriptionLocal } = useSelector(
    (state: any) => state.public
  );
  const { user } = useSelector((state: any) => state?.user);

  const { isSubscriptionResponse, isSubscriptionResponseData } = useSelector(
    (state: any) => state.adminCreation
  );

  const [isdurationError, setIsdurationError] = useState(false);
  const [isPaymentError, setIsPaymentError] = useState(false);
  const [durationOptions, setDurationOptions] = useState([]);
  const [isChange, setIsChange] = useState(false);
  const [formData, setFormData]: any = React.useState({});
  const [isActionCalled, setIsActionCalled] = useState(false);

  const classes = useStyles();

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isCalledAction, setIsCalledAction] = useState(false);

  const handleClear = () => {
    setAlertModelShow(true);
  };

  const hideHandler = () => {
    onHide();
    dispatch(resetSubscriptionLocal());
    setIsdurationError(false);
    setIsPaymentError(false);
  };

  useEffect(() => {
    const selectedPlan = plans.find(
      (item: any) => item?.id === newSubscriptionLocal?.planId
    );

    const durationArray =
      selectedPlan && selectedPlan?.durations
        ? selectedPlan?.durations?.map((item: any) => ({
            id: item,
            label:
              item === "5D"
                ? "5 Days Trial"
                : item === "3M"
                ? "3 Months"
                : item === "6M"
                ? "6 Months"
                : item === "12M"
                ? "12 Months"
                : item,
          }))
        : [];
    setDurationOptions(durationArray);
    let obj: any = {};
    if (newSubscriptionLocal?.duration && selectedPlan) {
      if (
        selectedPlan?.durations &&
        selectedPlan?.durations.includes(newSubscriptionLocal?.duration)
      ) {
        const selectedPlan = plans.find(
          (item: any) => item?.id === newSubscriptionLocal?.planId
        );
        const totalConst: any =
          newSubscriptionLocal?.duration === "5D"
            ? 0
            : newSubscriptionLocal?.duration === "monthly"
            ? selectedPlan?.price * 1
            : newSubscriptionLocal?.duration === "yearly"
            ? selectedPlan?.price * 12
            : selectedPlan?.price * parseInt(newSubscriptionLocal?.duration);
        let cusStartDate = new Date().toISOString();
        let cusRenewsOn = "";
        let cusEndDate = "";
        if (newSubscriptionLocal?.duration === "5D") {
          const dT = dayjs(cusStartDate).add(
            parseInt(newSubscriptionLocal?.duration),
            "day"
          );
          cusEndDate = dT.format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        if (
          newSubscriptionLocal?.duration === "3M" ||
          newSubscriptionLocal?.duration === "6M" ||
          newSubscriptionLocal?.duration === "12M"
        ) {
          const dT = dayjs(cusStartDate).add(
            parseInt(newSubscriptionLocal?.duration),
            "month"
          );
          cusEndDate = dayjs(cusStartDate)
            .add(parseInt(newSubscriptionLocal?.duration), "month")
            .format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        // for monthly
        if (newSubscriptionLocal?.duration === "monthly") {
          const dT = dayjs(cusStartDate).add(parseInt("1"), "month");
          cusEndDate = dayjs(cusStartDate)
            .add(parseInt("1"), "month")
            .format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        // for yearly
        if (newSubscriptionLocal?.duration === "yearly") {
          const dT = dayjs(cusStartDate).add(parseInt("12"), "month");
          cusEndDate = dayjs(cusStartDate)
            .add(parseInt("12"), "month")
            .format("DD/MM/YYYY");
          cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
        }
        obj = {
          subscriptionCost: totalConst,
          discount:
            newSubscriptionLocal?.duration === "5D"
              ? 0
              : !isChange
              ? newSubscriptionLocal?.discount
              : selectedPlan?.discount,
          amountPayable:
            newSubscriptionLocal?.duration === "5D"
              ? 0
              : selectedPlan?.discount && selectedPlan?.price
              ? totalConst -
                (totalConst *
                  (!isChange
                    ? newSubscriptionLocal?.discount
                    : selectedPlan?.discount)) /
                  100
              : "",
          startDate: isChange
            ? cusStartDate
            : newSubscriptionLocal?.startDate || "",
          endDate: isChange ? cusEndDate : newSubscriptionLocal?.endDate || "",
          renewsOn: isChange
            ? cusRenewsOn
            : newSubscriptionLocal?.renewsOn || "",
          paymentMethod: "Go Cardless Subscription",
        };
        // if (obj?.duration && obj?.duration !== "5D") {
        //   // checkBank();
        // }
      } else {
        obj = {
          duration: "",
          subscriptionCost: "",
          discount: "",
          amountPayable: "",
          term: "",
          startDate: "",
          endDate: "",
          renewsOn: "",
        };
        setIsdurationError(true);
        // setIsPaymentError(true);
      }
      dispatch(
        setNewSubscriptionLocal({
          ...newSubscriptionLocal,
          ...obj,
        })
      );
    } else {
      if (selectedPlan) {
        setIsdurationError(true);
        // if (newSubscriptionLocal?.paymentMethod==="") {
        //   setIsPaymentError(true);
        // } else {
        //   setIsPaymentError(false);
        // }
      }
    }
  }, [plans, newSubscriptionLocal?.planId]);

  // Extract plan names from the plans array
  const plansName = plans.map((item: any) => ({
    id: item?.id,
    label: item?.plan_name,
  }));

  // Update the subscription field to include plan options
  const updatedFields = subscriptionPlanFields.map((field) => {
    if (field.id === "planId") {
      return { ...field, options: plansName, type: "select" };
    }
    return field;
  });

  useEffect(() => {
    if (selectClient) {
      dispatch(
        setNewSubscriptionLocal({
          ...newSubscriptionLocal,
          planId: selectClient?.id, // Set the plan ID
        })
      );
      setIsCalledAction(false);
    }
  }, [selectClient, isCalledAction]);

  const handleFormValueChange = (field: string, value: any) => {
    setIsChange(true);
    let obj: any = {};
    if (field === "duration") {
      const selectedPlan = plans.find(
        (item: any) => item?.id === newSubscriptionLocal?.planId
      );
      const totalConst: any =
        value === "5D"
          ? 0
          : value === "monthly"
          ? selectedPlan?.price * 1
          : value === "yearly"
          ? selectedPlan?.price * 12
          : selectedPlan?.price * parseInt(value);
      let cusStartDate = new Date().toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";
      if (value === "5D") {
        const dT = dayjs(cusStartDate).add(parseInt(value), "day");
        cusEndDate = dT.format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      if (value === "3M" || value === "6M" || value === "12M") {
        const dT = dayjs(cusStartDate).add(parseInt(value), "month");
        cusEndDate = dayjs(cusStartDate)
          .add(parseInt(value), "month")
          .format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      // for monthly
      if (value === "monthly") {
        const dT = dayjs(cusStartDate).add(parseInt("1"), "month");
        cusEndDate = dayjs(cusStartDate)
          .add(parseInt("1"), "month")
          .format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      // for yearly
      if (value === "yearly") {
        const dT = dayjs(cusStartDate).add(parseInt("12"), "month");
        cusEndDate = dayjs(cusStartDate)
          .add(parseInt("12"), "month")
          .format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      setIsdurationError(false);

      obj = {
        duration: value,
        subscriptionCost: totalConst,
        discount: value === "5D" ? 0 : selectedPlan?.discount,
        amountPayable:
          value === "5D"
            ? 0
            : selectedPlan?.discount && selectedPlan?.price
            ? totalConst - (totalConst * selectedPlan?.discount) / 100
            : "",
        term: [dayjs(cusStartDate), dayjs(cusEndDate)],
        startDate: cusStartDate,
        endDate: cusEndDate,
        renewsOn: cusRenewsOn,
        paymentMethod: "Go Cardless Subscription",
      };
    }
    // if (field === "paymentMethod") {
    //   if (newSubscriptionLocal?.paymentMethod === "") {
    //     setIsPaymentError(true);
    //   } else {
    //     setIsPaymentError(false);
    //   }
    // }

    if (field === "discount") {
      const selectedPlan = plans.find(
        (item: any) => item?.id === newSubscriptionLocal?.planId
      );
      const disValue = !value ? 0 : value;
      const totalConst: any =
        newSubscriptionLocal?.duration === "5D"
          ? 0
          : selectedPlan?.price * parseInt(newSubscriptionLocal?.duration);
      obj = {
        discount: value,
        amountPayable:
          newSubscriptionLocal?.duration === "5D"
            ? 0
            : disValue && selectedPlan?.price
            ? totalConst - (totalConst * disValue) / 100
            : totalConst,
      };
    }
    if (field === "term") {
      let cusStartDate = new Date(value).toISOString();
      let cusRenewsOn = "";
      let cusEndDate = "";
      if (newSubscriptionLocal["duration"] === "5D") {
        const dT = dayjs(cusStartDate).add(
          parseInt(newSubscriptionLocal["duration"]),
          "day"
        );
        cusEndDate = dT.format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      if (
        newSubscriptionLocal["duration"] === "3M" ||
        newSubscriptionLocal["duration"] === "6M" ||
        newSubscriptionLocal["duration"] === "12M" ||
        newSubscriptionLocal["duration"] === "monthly" ||
        newSubscriptionLocal["duration"] === "yearly"
      ) {
        const dT = dayjs(cusStartDate).add(
          parseInt(
            newSubscriptionLocal["duration"] === "monthly"
              ? "1"
              : newSubscriptionLocal["duration"] === "yearly"
              ? "12"
              : newSubscriptionLocal["duration"]
          ),
          "month"
        );
        cusEndDate = dT.format("DD/MM/YYYY");
        cusRenewsOn = dayjs(dT).add(1, "day").format("DD/MM/YYYY");
      }
      obj = {
        startDate: cusStartDate,
        endDate: cusEndDate,
        renewsOn: cusRenewsOn,
        //renewsOn: value ? (dayjs(value).add(parseInt(newSubscriptionLocal?.duration), "day")) : ""
      };
    }

    // if (field === "planId") {
    //   if (!newSubscriptionLocal?.duration) {
    //     setIsdurationError(true);
    //     // setIsPaymentError(true);
    //   }
    // }

    dispatch(
      setNewSubscriptionLocal({
        ...newSubscriptionLocal,
        [field]: value,
        // ...{ ...(field === "planId" && { duration: "" }) },
        ...obj,
      })
    );
    setFormData((prevValues: any) => ({ ...prevValues, [field]: value }));
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isdurationError && !isPaymentError) {
        dispatch(
          addSubscriptionAction({
            ...newSubscriptionLocal,
            tenantId: user?.user?.tenantId,
          })
        );
        setIsActionCalled(false);
      } else {
        setIsActionCalled(false);
      }
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (!isSubscriptionResponse) return;

    hideHandler();
    dispatch(setAddSubscriptionAction(false));

    if (isNew) {
      const nextAction = isSubscriptionResponseData?.nextAction;

      if (nextAction === "make_payment") {
        navigate("/payments");
      } else if (nextAction === "dashboard") {
        navigate(user?.user?.is_new ? "/settings" : "/dashboard");
      }
    } else {
      onHide();
      dispatch(getClientForEditAction());
       dispatch(getUserProfile());
    }

    dispatch(resetSubscriptionLocal());
  }, [isSubscriptionResponse, isNew, isSubscriptionResponseData, user]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={props?.action === "plan" ? "Select Plan" : title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={handleClear}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <Notification />
            {updatedFields.map((field, i) => {
              // Skip rendering paymentMethod field if duration is "" or "5D"
              if (
                field.id === "paymentMethod" &&
                (newSubscriptionLocal?.duration === "" ||
                  newSubscriptionLocal?.duration === "5D")
              ) {
                return null;
              }

              return (
                selectClient && (
                  <Grid container spacing={2} key={i}>
                    <FormField
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(event: any) => {
                        console.log(
                          "event log-",
                          event,
                          event.target.value + event.key
                        );
                        if (
                          event.keyCode === 8 ||
                          event.keyCode === 9 ||
                          event.keyCode === 37 ||
                          event.keyCode === 38 ||
                          event.keyCode === 39 ||
                          event.keyCode === 40 ||
                          event.keyCode === 18 ||
                          event.keyCode === 17 ||
                          event.ctrlKey
                        )
                          return event;
                        if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(event.key)
                        ) {
                          event.preventDefault();
                        } else if (
                          field?.patternAllowed &&
                          !field?.patternAllowed.test(
                            event.target.value + event.key
                          )
                        ) {
                          event.preventDefault();
                        }
                      }}
                      {...{
                        ...(field?.id === "term" && {
                          renewsOn: newSubscriptionLocal["endDate"],
                        }),
                        ...field,
                        value: newSubscriptionLocal
                          ? field?.id === "term"
                            ? newSubscriptionLocal["startDate"]
                            : newSubscriptionLocal[field?.id]
                          : "",
                        defaultValue: newSubscriptionLocal
                          ? field?.id === "term"
                            ? newSubscriptionLocal["startDate"]
                            : newSubscriptionLocal[field?.id]
                          : "",
                        ...{
                          ...(field?.id === "duration" && {
                            options: durationOptions,
                          }),
                        },
                      }}
                      // disabled={field?.disabled ?? false}
                      InputProps={{
                        ...(newSubscriptionLocal["duration"] === "5D" &&
                          field?.id === "discount" && { disabled: true }),
                        ...(newSubscriptionLocal["duration"] === "" &&
                          field?.id === "term" && { disabled: true }),
                        ...(newSubscriptionLocal["planId"] === "" &&
                          field?.id === "duration" && { disabled: true }),
                        sx:
                          field.type === "text" || field.type === "number"
                            ? { height: "36px" }
                            : { padding: "10px 4px", height: "36px" },
                      }}
                      selectedValues={formData[field.id]}
                      onChange={(e: any) =>
                        handleFormValueChange(field.id, e.target.value)
                      }
                      error={
                        field?.id === "duration"
                          ? isdurationError
                          : field?.id === "paymentMethod"
                          ? isPaymentError
                          : false
                      }
                    />
                  </Grid>
                )
              );
            })}
            {newSubscriptionLocal?.duration !== "5D" &&
              newSubscriptionLocal?.duration !== "" && (
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    marginTop: "10px",
                    fontSize: "13px",
                  }}
                >
                  <span style={{ color: "#d97c7c" }}>
                    In case of Gocardless Subscription.:-{" "}
                  </span>
                  <br />
                  The client will receive an email with a payment link. Once
                  they pay the amount successfully, their Manage My Moves
                  subscription of £ {
                    newSubscriptionLocal?.amountPayable
                  } per{" "}
                  {newSubscriptionLocal?.duration === "monthly"
                    ? "month"
                    : " year"}{" "}
                  will be started.
                </Typography>
              )}
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          setIsCalledAction={setIsCalledAction}
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsdurationError={setIsdurationError}
          setIsPaymentError={setIsPaymentError}
        />
      )}
    </>
  );
};

export default ManageSelectPlan;
